import { ref } from 'vue';
import { adminApi, clearAdminToken, getAdminToken, setAdminToken } from '@/lib/api';

export type AdminUser = { id?: string; email?: string; displayName?: string };

const admin = ref<AdminUser | null>(null);
const booting = ref(true);

export function useAdminSession() {
  async function refreshMe(): Promise<boolean> {
    if (!getAdminToken()) {
      admin.value = null;
      return false;
    }
    try {
      const data = await adminApi<{ admin: AdminUser }>('/v1/admin/me');
      admin.value = data.admin;
      return true;
    } catch {
      clearAdminToken();
      admin.value = null;
      return false;
    }
  }

  async function login(email: string, password: string) {
    const data = await adminApi<{ token: string; admin: AdminUser }>('/v1/admin/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
    setAdminToken(data.token);
    admin.value = data.admin;
    return data.admin;
  }

  async function logout() {
    try {
      await adminApi('/v1/admin/logout', { method: 'POST' });
    } catch {
      /* ignore */
    }
    clearAdminToken();
    admin.value = null;
  }

  async function boot() {
    booting.value = true;
    try {
      await refreshMe();
    } finally {
      booting.value = false;
    }
  }

  return { admin, booting, refreshMe, login, logout, boot };
}
